import DynamicFieldConfigType from "../types/DynamicFieldConfigType";
import FieldAlias from "../enums/FieldAlias";
import useNavigateWrapper from "shared/hooks/useNavigateWrapper";
import Button from "shared/components/button";
import { ConsoleRouteMap } from "apps/console/routes/routes";
import { useCopies } from "shared/hooks/useCopies";

export default function FormLabelWithActionWrapper(props: DynamicFieldConfigType) {
  return <GetActionByFieldAlias fieldAlias={props.schemaObj.alias} />;
}
function GetActionByFieldAlias(props: { fieldAlias?: string | null }) {
  const { navigate } = useNavigateWrapper();
  const copies = useCopies();
  switch (props.fieldAlias) {
    case FieldAlias.LOCATION_ACTION_SHORTCUT:
      return (
        <div className="form_item form_item--fullWidth redirectToLocationAction">
          <div className="redirectToLocationAction_wrapper">
            {copies.get("location.shortcut.label.text")}
            <Button.Link
              label={copies.get("create.event.location")}
              onClick={() => {
                navigate(ConsoleRouteMap.REGISTRATION.EVENT.EVENT_ORGANIZATION.DETAIL.ADD_LOCATION.path);
              }}
            />
          </div>
        </div>
      );
    default:
      return null;
  }
}
